import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const removeEstimateUser = async (formData: FormData) => {
    // @ts-ignore
    const url = routable.getRoute('removeEstimateUser');

    try {
        return await $api.post(url, formData);
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error;
    }
};
